export default __webpack_public_path__ + "static/media/Calibre-Bold.4d02910a.woff";